import { useCallback, useEffect } from 'react';
import { interceptFocus } from './ModalOverlay.utils.js';
export const useModalCloseEvents = (onClose, closeOnEsc, closeOnOutsideClick, modalRef, overlayRef) => {
    const onKeyDownCallback = useCallback((event) => {
        const isEscPressed = event.key === 'Escape' || event.keyCode === 27;
        const isTabPressed = event.key === 'Tab' || event.keyCode === 9;
        if (isEscPressed && closeOnEsc) {
            onClose();
            return;
        }
        if (isTabPressed) {
            interceptFocus(event, modalRef);
        }
    }, [closeOnEsc, modalRef, onClose]);
    const onOverlayClick = useCallback((event) => {
        if (!closeOnOutsideClick) {
            return;
        }
        const isNonPrimaryButtonPressed = event.button !== undefined && event.button !== 0;
        if (isNonPrimaryButtonPressed || event.target !== overlayRef.current) {
            return;
        }
        onClose();
    }, [overlayRef, closeOnOutsideClick, onClose]);
    useEffect(() => {
        document.addEventListener('keydown', onKeyDownCallback);
        return () => {
            document.removeEventListener('keydown', onKeyDownCallback);
        };
    }, [onKeyDownCallback]);
    return {
        onOverlayClick,
    };
};
